(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require("./nucal");

},{"./nucal":2}],2:[function(require,module,exports){
"use strict";

var _NuCalController = _interopRequireDefault(require("nucal/controllers/NuCalController"));

var _NuCalAnnouncerView = _interopRequireDefault(require("nucal/views/NuCalAnnouncerView.js"));

var _NuCalSingleCalendarWidget = _interopRequireDefault(require("nucal/views/composites/NuCalSingleCalendarWidget.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//the controller manages the arrival departure date
//the announcer announces for screen readers
//this is the calendar widget which contains the individual
var bookingNode = document.querySelector('.cp-header__booking');
console.log(bookingNode);

if (bookingNode.classList.contains('cp-header__booking--nucal')) {
  console.log('NuCal active');

  var toggleRenderTemplate = function toggleRenderTemplate(date) {
    this.view.innerHTML = "\n    <div class=\"cp-booking-widget__column-content--month\">".concat(date.toLocaleDateString(this.locale, {
      'month': 'long'
    }), "</div>\n    <div class=\"cp-booking-widget__column-content--figure\">").concat(date.toLocaleDateString(this.locale, {
      'day': 'numeric'
    }), "</div>\n    <div class=\"cp-booking-widget__column-content--controls cp-booking-widget__column-content--controls-down\">\n        <span class=\"icon-arrow-down\"></span>\n    </div>\n    ");
  };

  var arrivalCalendar = new _NuCalSingleCalendarWidget["default"]({
    'view': document.querySelector('.cp-booking-widget__arrival .cp-booking-widget__column-content'),
    //this is the div or element in which we create and render the calendar
    'namespace': 'mainCalendar',
    //use the same namespace to keep all related Modules in sync.
    'dateType': 'arrival',
    //this can be arrival or departure
    'inputId': 'arrival',
    //the <input id="?">
    'inputName': 'arrival',
    //the <input name="?">
    'toggleRenderTemplate': toggleRenderTemplate
  });
  var departureCalendar = new _NuCalSingleCalendarWidget["default"]({
    'view': document.querySelector('.cp-booking-widget__departure .cp-booking-widget__column-content'),
    //this is the div or element in which we create and render the calendar
    'namespace': 'mainCalendar',
    //use the same namespace to keep all related Modules in sync.
    'dateType': 'departure',
    //this can be arrival or departure
    'inputId': 'departure',
    //the <input id="?">
    'inputName': 'departure',
    //the <input name="?">
    'toggleRenderTemplate': toggleRenderTemplate
  });
  var cal = new _NuCalController["default"]({
    'namespace': 'mainCalendar'
  });
  window.nucal = {
    'mainCalendar': cal,
    'arrivalCalendar': arrivalCalendar,
    'departureCalendar': departureCalendar
  };
}

},{"nucal/controllers/NuCalController":3,"nucal/views/NuCalAnnouncerView.js":9,"nucal/views/composites/NuCalSingleCalendarWidget.js":14}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Events = _interopRequireDefault(require("../utils/Events.js"));

var _General = require("../utils/General.js");

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* NuCalController.
* @param {Object} props properties.
* @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
* @param {Number} props.minNumberOfNights The minimum number of nights between the arrival and departure date. (Integer)
* @param {Number} props.maxNumberOfNights The maximum number of nights between the arrival and departure date. (Integer) 
* @param {Date} props.minDate The minimum date for the arrival date. 
* @param {Date} props.maxDate The maximum date for the departure date.
* @param {Date} props.arrivalDate The date of arrival. This must be before the departure date.
* @param {Date} props.departureDate The date of arrival. This must be after the arrival date.
*/
var NuCalController = /*#__PURE__*/function () {
  function NuCalController() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, NuCalController);

    this.namespace = props.namespace || (0, _v["default"])();
    this.minNumberOfNights = props.minNumberOfNights || 1;
    this.maxNumberOfNights = props.maxNumberOfNights || 365;
    this.minDate = props.minDate || new Date();

    this.maxDate = props.maxDate || function () {
      var d = new Date();
      d.setFullYear(d.getFullYear() + 2);
      return d;
    }();

    this.arrivalDate = props.arrivalDate || new Date();
    this.departureDate = props.departureDate || new Date();
    this.constructed = true;

    this._rationalizeDateRange({});
  }
  /**
      * The namespace in which this object should subscribe and publish events on.
      * @type {String}.
     */


  _createClass(NuCalController, [{
    key: "namespace",
    get: function get() {
      return this._namespace;
    },
    set: function set(n) {
      var _this = this;

      this._namespace = n;

      if (typeof n == "string" && this._namespace !== "") {
        n = "/" + n;
      } else {
        n = "";
      }

      this._events = {}; //sending

      this._events.datesUpdated = "/nuCal".concat(n, "/datesUpdated");
      this._events.arrivalDateUpdated = "/nuCal".concat(n, "/arrivalDateUpdated");
      this._events.departureDateUpdated = "/nuCal".concat(n, "/departureDateUpdated");
      this._events.minDateUpdated = "/nuCal".concat(n, "/minDateUpdated");
      this._events.maxDateUpdated = "/nuCal".concat(n, "/maxDateUpdated");
      this._events.numberOfNightsUpdated = "/nuCal".concat(n, "/numberOfNightsUpdated");
      this._events.minNumberOfNightsUpdated = "/nuCal".concat(n, "/minNumberOfNightsUpdated");
      this._events.maxNumberOfNightsUpdated = "/nuCal".concat(n, "/maxNumberOfNightsUpdated"); //receiving

      this._events.updateArrivalDate = "/nuCal".concat(n, "/updateArrivalDate");
      this._events.updateDepartureDate = "/nuCal".concat(n, "/updateDepartureDate");
      this._events.updateMinDate = "/nuCal".concat(n, "/updateMinDate");
      this._events.updateMaxDate = "/nuCal".concat(n, "/updateMaxDate");
      this._events.updateNumberOfNights = "/nuCal".concat(n, "/updateNumberOfNights");
      this._events.updateMinNumberOfNights = "/nuCal".concat(n, "/updateMinNumberOfNights");
      this._events.updateMaxNumberOfNights = "/nuCal".concat(n, "/updateMaxNumberOfNights");

      _Events["default"].subscribe(this._events.updateArrivalDate, function (props) {
        _this.arrivalDate = props.date;
      });

      _Events["default"].subscribe(this._events.updateDepartureDate, function (props) {
        _this.departureDate = props.date;
      });

      _Events["default"].subscribe(this._events.updateMinDate, function (props) {
        _this.minDate = props.date;
      });

      _Events["default"].subscribe(this._events.updateMaxDate, function (props) {
        _this.maxDate = props.date;
      });

      _Events["default"].subscribe(this._events.updateMinNumberOfNights, function (props) {
        _this.minNumberOfNights = props.minNumberOfNights;
      });

      _Events["default"].subscribe(this._events.updateMaxNumberOfNights, function (props) {
        _this.maxNumberOfNights = props.maxNumberOfNights;
      });

      _Events["default"].subscribe(this._events.updateNumberOfNights, function (props) {
        _this.numberOfNights = props.numberOfNights;
      });
    }
    /**
        * The minimum date for the arrival date.
        * @type {Date}.
       */

  }, {
    key: "minDate",
    get: function get() {
      return this._minDate;
    },
    set: function set(nuMinDate) {
      if (nuMinDate instanceof Date && nuMinDate.toString() !== "Invalid Date") {
        this._minDate = new Date(nuMinDate.getFullYear(), nuMinDate.getMonth(), nuMinDate.getDate());
      } else {
        return false;
      }

      var changes = {};
      changes.minDate = true;

      this._rationalizeDateRange(changes);
    }
    /**
        * The maximum date for the departure date.
        * @type {Date}.
       */

  }, {
    key: "maxDate",
    get: function get() {
      return this._maxDate;
    },
    set: function set(nuMaxDate) {
      if (nuMaxDate instanceof Date && nuMaxDate.toString() !== "Invalid Date") {
        this._maxDate = new Date(nuMaxDate.getFullYear(), nuMaxDate.getMonth(), nuMaxDate.getDate());
      } else {
        return false;
      }

      var changes = {};
      changes.maxDate = true;

      this._rationalizeDateRange(changes);
    }
    /**
        * The number of nights between the arrival and departure date.
        * When this is explicitly set then it becomes fixed and the departure
        * date will adjust as the arrival date changes. If the departure date is
        * explicitly set then this property becomes dynamic and reflex the difference
        * between the arrival and departure date. (Integer)
        * @type {Number}.
       */

  }, {
    key: "numberOfNights",
    get: function get() {
      return (0, _General.daysBetween)(this._arrivalDate, this._departureDate);
    },
    set: function set(value) {
      if (value >= this.minNumberOfNights) {
        if (this.maxNumberOfNights !== null && value > this.maxNumberOfNights) {
          return;
        }

        this._fixedNumberOfNights = parseInt(value);
        var changes = {};
        changes.numberOfNights = true;

        this._rationalizeDateRange(changes);
      }
    }
    /**
        * The minimun number of nights between the arrival and departure date. (Integer)
        * @type {Number}.
       */

  }, {
    key: "minNumberOfNights",
    get: function get() {
      return parseInt(this._minNumberOfNights);
    },
    set: function set(nuMinNo) {
      if (typeof nuMinNo === "number" && nuMinNo >= 1) {
        this._minNumberOfNights = nuMinNo;
      } else {
        if (typeof this._minNumberOfNights === "undefined") this._minNumberOfNights = 1;
      }

      var changes = {};
      changes.minNumberOfNights = true;

      this._rationalizeDateRange(changes);
    }
    /**
        * The maximum number of nights between the arrival and departure date.
        * @type {Number}.
       */

  }, {
    key: "maxNumberOfNights",
    get: function get() {
      return parseInt(this._maxNumberOfNights) || null;
    },
    set: function set(nuMaxNo) {
      if (typeof nuMaxNo === "number" || nuMaxNo === null) {
        this._maxNumberOfNights = nuMaxNo;
      } else {
        if (typeof this._maxNumberOfNights === "undefined") this._maxNumberOfNights = null;
      }

      var changes = {};
      changes.maxNumberOfNights = true;

      this._rationalizeDateRange(changes);
    }
    /**
        * The date of arrival. This must be before the departure date.
        * @type {Date}
       */

  }, {
    key: "arrivalDate",
    get: function get() {
      return this._arrivalDate;
    },
    set: function set(nuArrivalDate) {
      if (nuArrivalDate instanceof Date && nuArrivalDate.toString() !== "Invalid Date") {
        this._arrivalDate = new Date(nuArrivalDate.getFullYear(), nuArrivalDate.getMonth(), nuArrivalDate.getDate());
      }

      var changes = {};
      changes.arrivalDate = true;

      this._rationalizeDateRange(changes);
    }
    /**
        * The date of departure. This must be before the departure date.
        * @type {Date}
       */

  }, {
    key: "departureDate",
    get: function get() {
      return this._departureDate;
    },
    set: function set(nuDepartureDate) {
      if (nuDepartureDate instanceof Date && nuDepartureDate.toString() !== "Invalid Date") {
        this._fixedNumberOfNights = null;
        this._departureDate = new Date(nuDepartureDate.getFullYear(), nuDepartureDate.getMonth(), nuDepartureDate.getDate());
      }

      var changes = {};
      changes.departureDate = true;

      this._rationalizeDateRange(changes);
    }
    /**
        * The minimum possible arrival date given the current settings. (read-only)
        * @type {Date}
        * @readonly
       */

  }, {
    key: "minArrivalDate",
    get: function get() {
      return new Date(this.minDate.getFullYear(), this.minDate.getMonth(), this.minDate.getDate());
    }
    /**
        * The minimum possible departure date given the current settings. (read-only)
        * @type {Date}
        * @readonly
       */

  }, {
    key: "minDepartureDate",
    get: function get() {
      return new Date(this.arrivalDate.getFullYear(), this.arrivalDate.getMonth(), this.arrivalDate.getDate() + this.minNumberOfNights);
    }
    /**
        * The maximum possible arrival date given the current settings. (read-only)
        * @type {Date}
        * @readonly
       */

  }, {
    key: "maxArrivalDate",
    get: function get() {
      return new Date(this.maxDate.getFullYear(), this.maxDate.getMonth(), this.maxDate.getDate() - this.minNumberOfNights);
    }
    /**
        * The maximum possible departure date given the current settings. (read-only)
        * @type {Date}
        * @readonly
       */

  }, {
    key: "maxDepartureDate",
    get: function get() {
      if (this.maxNumberOfNights === null) return new Date(this.maxDate.getFullYear(), this.maxDate.getMonth(), this.maxDate.getDate());else return new Date(this.arrivalDate.getFullYear(), this.arrivalDate.getMonth(), this.arrivalDate.getDate() + this.maxNumberOfNights);
    }
    /**
        * Private. Enforces logical rules and such as the departure date being before the arrival date.
        * @private
        * @type {Undefined}
       */

  }, {
    key: "_rationalizeDateRange",
    value: function _rationalizeDateRange() {
      var changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.constructed) return;

      if (this.minDate instanceof Date) {
        var minArrivalDate = new Date(this.minArrivalDate.valueOf());
        var minDepartureDate = new Date(this.minDepartureDate.valueOf());

        if (+this.arrivalDate <= +minArrivalDate) {
          this._arrivalDate = minArrivalDate;
          changes.arrivalDate = true;
        }

        if (+this.departureDate <= +minDepartureDate) {
          this._departureDate = minDepartureDate;
          changes.departureDate = true;
        }
      }

      if (this.maxDate instanceof Date) {
        var maxArrivalDate = new Date(this.maxArrivalDate.valueOf());
        var maxDepartureDate = new Date(this.maxDepartureDate.valueOf());

        if (+this.arrivalDate >= +maxArrivalDate) {
          this._arrivalDate = maxArrivalDate;
          changes.arrivalDate = true;
        }

        if (+this.departureDate >= +maxDepartureDate) {
          this._departureDate = maxDepartureDate;
          changes.departureDate = true;
        }
      }

      if (+this.arrivalDate >= +this.departureDate) {
        var tomorrow = new Date(this.arrivalDate.getFullYear(), this.arrivalDate.getMonth(), this.arrivalDate.getDate());
        tomorrow.setDate(tomorrow.getDate() + this.minNumberOfNights);
        this._departureDate = tomorrow;
        changes.departureDate = true;
      }

      if (this._fixedNumberOfNights) {
        this._departureDate = new Date(this.arrivalDate.getFullYear(), this.arrivalDate.getMonth(), this.arrivalDate.getDate() + this._fixedNumberOfNights);

        if (+this._departureDate > +this.maxDate) {
          this._departureDate = new Date(this.maxDate.valueOf());
        }
      }

      this._triggerEvents(changes);
    }
    /**
        * Private. Publishes events for each property that has changed.
        * @private
        * @type {Undefined}
       */

  }, {
    key: "_triggerEvents",
    value: function _triggerEvents(changes) {
      if (changes.arrivalDate) {
        _Events["default"].publish(this._events.arrivalDateUpdated, {
          "arrivalDate": new Date(this.arrivalDate.valueOf())
        });
      }

      if (changes.departureDate) {
        _Events["default"].publish(this._events.departureDateUpdated, {
          "departureDate": new Date(this.departureDate.valueOf())
        });
      }

      if (changes.numberOfNights) {
        _Events["default"].publish(this._events.numberOfNightsUpdated, {
          "departureDate": new Date(this.departureDate.valueOf())
        });
      }

      if (changes.maxDate && this.maxDate instanceof Date) {
        _Events["default"].publish(this._events.maxDateUpdated, {
          "maxDate": new Date(this.maxDate.valueOf())
        });
      }

      if (changes.minDate && this.minDate instanceof Date) {
        _Events["default"].publish(this._events.minDateUpdated, {
          "minDate": new Date(this.minDate.valueOf())
        });
      }

      if (changes.maxNumberOfNights && this.maxNumberOfNights instanceof Number) {
        _Events["default"].publish(this._events.maxNumberOfNightsUpdated, {
          "maxNumberOfNights": this.maxNumberOfNights
        });
      }

      if (changes.minNumberOfNights && this.minNumberOfNights instanceof Number) {
        _Events["default"].publish(this._events.minNumberOfNightsUpdated, {
          "minNumberOfNights": this.minNumberOfNights
        });
      }

      if (Object.keys(changes).length > 0) {
        var props = {};
        props.arrivalDate = this.arrivalDate instanceof Date ? new Date(this.arrivalDate.getFullYear(), this.arrivalDate.getMonth(), this.arrivalDate.getDate()) : null;
        props.departureDate = this.departureDate instanceof Date ? new Date(this.departureDate.getFullYear(), this.departureDate.getMonth(), this.departureDate.getDate()) : null;
        props.minDate = this.minDate instanceof Date ? new Date(this.minDate.valueOf()) : null;
        props.maxDate = this.maxDate instanceof Date ? new Date(this.maxDate.valueOf()) : null;

        if (this.minDate instanceof Date) {
          props.minArrivalDate = new Date(this.minArrivalDate.valueOf());
          props.minDepartureDate = new Date(this.minDepartureDate.valueOf());
        }

        if (this.maxDate instanceof Date) {
          props.maxArrivalDate = new Date(this.maxArrivalDate.valueOf());
          props.maxDepartureDate = new Date(this.maxDepartureDate.valueOf());
        }

        props.minNumberOfNights = this.minNumberOfNights;
        props.maxNumberOfNights = this.maxNumberOfNights;

        if (this.arrivalDate instanceof Date && this.departureDate instanceof Date) {
          _Events["default"].publish(this._events.datesUpdated, props);
        }
      }
    }
  }]);

  return NuCalController;
}();

var _default = NuCalController;
exports["default"] = _default;

},{"../utils/Events.js":5,"../utils/General.js":6,"uuid/v4":17}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isMergeableObject(val) {
  var nonNullObject = val && _typeof(val) === "object";
  return nonNullObject && Object.prototype.toString.call(val) !== "[object RegExp]" && Object.prototype.toString.call(val) !== "[object Date]";
}

function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}

function cloneIfNecessary(value, optionsArgument) {
  var clone = optionsArgument && optionsArgument.clone === true;
  return clone && isMergeableObject(value) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
}

function defaultArrayMerge(target, source, optionsArgument) {
  var destination = target.slice();
  source.forEach(function (e, i) {
    if (typeof destination[i] === "undefined") {
      destination[i] = cloneIfNecessary(e, optionsArgument);
    } else if (isMergeableObject(e)) {
      destination[i] = deepmerge(target[i], e, optionsArgument);
    } else if (target.indexOf(e) === -1) {
      destination.push(cloneIfNecessary(e, optionsArgument));
    }
  });
  return destination;
}

function mergeObject(target, source, optionsArgument) {
  var destination = {};

  if (isMergeableObject(target)) {
    Object.keys(target).forEach(function (key) {
      destination[key] = cloneIfNecessary(target[key], optionsArgument);
    });
  }

  Object.keys(source).forEach(function (key) {
    if (!isMergeableObject(source[key]) || !target[key]) {
      destination[key] = cloneIfNecessary(source[key], optionsArgument);
    } else {
      destination[key] = deepmerge(target[key], source[key], optionsArgument);
    }
  });
  return destination;
}

function deepmerge(target, source, optionsArgument) {
  var array = Array.isArray(source);
  var options = optionsArgument || {
    arrayMerge: defaultArrayMerge
  };
  var arrayMerge = options.arrayMerge || defaultArrayMerge;

  if (array) {
    return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument);
  } else {
    return mergeObject(target, source, optionsArgument);
  }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
  if (!Array.isArray(array) || array.length < 2) {
    throw new Error("first argument should be an array with at least two elements");
  } // we are sure there are at least 2 values, so it is safe to have no initial value


  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, optionsArgument);
  });
};

var _default = deepmerge;
exports["default"] = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Events = function () {
  var topics = {};
  var hOP = topics.hasOwnProperty;
  return {
    subscribe: function subscribe(topic, listener) {
      // Create the topic's object if not yet created
      if (!hOP.call(topics, topic)) topics[topic] = []; // Add the listener to queue

      var index = topics[topic].push(listener) - 1; // Provide handle back for removal of topic

      return {
        remove: function remove() {
          delete topics[topic][index];
        }
      };
    },
    publish: function publish(topic, info) {
      // If the topic doesn't exist, or there's no listeners in queue, just leave
      if (!hOP.call(topics, topic)) return; // Cycle through topics queue, fire!

      topics[topic].forEach(function (item) {
        item(info != undefined ? info : {});
      });
    }
  };
}();

var _default = Events;
exports["default"] = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrdinal = getOrdinal;
exports.getNextMonth = getNextMonth;
exports.getPreviousMonth = getPreviousMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getDaysInNextMonth = getDaysInNextMonth;
exports.getDaysInPrevMonth = getDaysInPrevMonth;
exports.getMonthPadding = getMonthPadding;
exports.daysBetween = daysBetween;
exports.zeroPadNumber = zeroPadNumber;
exports.isChild = isChild;
exports.getFocusableElements = getFocusableElements;
exports.focusLock = focusLock;
exports.focusableElementsQuery = void 0;

function getOrdinal(d) {
  if (d > 3 && d < 21) return "th";

  switch (d % 10) {
    case 1:
      return "st";

    case 2:
      return "nd";

    case 3:
      return "rd";

    default:
      return "th";
  }
}

function getNextMonth(d) {
  var daysInNextMonth = getDaysInNextMonth(d);
  return new Date(d.getFullYear(), d.getMonth() + 1, Math.min(daysInNextMonth, d.getDate()));
}

function getPreviousMonth(d) {
  var daysInPrevMonth = getDaysInPrevMonth(d);
  return new Date(d.getFullYear(), d.getMonth() - 1, Math.min(daysInPrevMonth, d.getDate()));
}

function getDaysInMonth(d) {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
}

function getDaysInNextMonth(d) {
  return new Date(d.getFullYear(), d.getMonth() + 2, 0).getDate();
}

function getDaysInPrevMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 0).getDate();
}

function getMonthPadding(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1).getDay();
}

function daysBetween(dt1, dt2) {
  return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
}

function zeroPadNumber(number, length) {
  var str = "" + number;

  while (str.length < length) {
    str = "0" + str;
  }

  return str;
}

function isChild(obj, parentObj) {
  while (obj != undefined && obj != null && obj.tagName.toUpperCase() != "BODY") {
    if (obj == parentObj) {
      return true;
    }

    obj = obj.parentNode;
  }

  return false;
}

var focusableElementsQuery = "button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])";
exports.focusableElementsQuery = focusableElementsQuery;

function getFocusableElements(el) {
  return el.querySelectorAll(focusableElementsQuery);
}

function focusLock(event, parent) {
  //the event should be a blur event. check if the relatedTarget is inside or
  //outside our parent to decide what to do. This should only be called if the 
  //view/widget is active.
  var newFocusEl = event.relatedTarget;
  var prevFocusEl = event.target;
  var focusable = getFocusableElements(parent);
  var firstFocusable = focusable[0];
  var lastFocusable = focusable[focusable.length - 1];

  if (!isChild(newFocusEl, parent)) {
    //if the newly focused element isn't a child
    switch (prevFocusEl) {
      case firstFocusable:
        lastFocusable.focus();
        break;

      case lastFocusable:
        firstFocusable.focus();
        break;
    }
  }
}

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Deepmerge = _interopRequireDefault(require("../Deepmerge"));

var _enUS = _interopRequireDefault(require("./translations/en-US"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LexiconManager = /*#__PURE__*/function () {
  function LexiconManager() {
    _classCallCheck(this, LexiconManager);

    this.lexicons = {};
  }

  _createClass(LexiconManager, [{
    key: "addLexicon",
    value: function addLexicon(langCode, newLexi) {
      this.lexicons[langCode] = (0, _Deepmerge["default"])(_enUS["default"], newLexi);
    }
  }, {
    key: "removeLexicon",
    value: function removeLexicon(langCode) {
      delete this.lexicons[langCode];
    }
  }, {
    key: "getLexicon",
    value: function getLexicon() {
      var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en-US";
      var overwrite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!Object.prototype.hasOwnProperty.call(this.lexicons, lang)) {
        lang = "en-US";
      }

      return _objectSpread(_objectSpread({}, this.lexicons[lang]), overwrite);
    }
  }]);

  return LexiconManager;
}();

var lexiMan = new LexiconManager();
lexiMan.addLexicon("en-US", _enUS["default"]);
var _default = lexiMan;
exports["default"] = _default;

},{"../Deepmerge":4,"./translations/en-US":8}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  'NuCalNumberOfNightsView': {
    'incrementButtonAria': 'Increase number of nights by 1',
    'decrementButtonAria': 'Decrease number of nights by 1'
  },
  'NuCalAnnouncerView': {
    'arrivalText': 'the arrival date is [date].',
    'departureText': 'The departure date is [date].'
  },
  'NuCalSingleCalendarView': {
    'nextLabel': 'Next',
    'nextLabelAria': 'Next Month',
    'previousLabel': 'Previous',
    'previousLabelAria': 'Previous Month'
  },
  'NuCalSelectView': {
    'departure': {
      'dayLabel': 'Day',
      'daySelectAria': 'Departure Day',
      'monthLabel': 'Month',
      'monthSelectAria': 'Departure Month',
      'yearLabel': 'Year',
      'yearSelectAria': 'Departure Year'
    },
    'arrival': {
      'dayLabel': 'Day',
      'daySelectAria': 'Arrival Day',
      'monthLabel': 'Month',
      'monthSelectAria': 'Arrival Month',
      'yearLabel': 'Year',
      'yearSelectAria': 'Arrival Year'
    }
  }
};
exports["default"] = _default;

},{}],9:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Events = _interopRequireDefault(require("../utils/Events.js"));

var _NuCalBaseView2 = _interopRequireDefault(require("./NuCalBaseView.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @extends NuCalBaseView
 * @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
 * @param {HTMLElement} props.view The HTML Element in which this object should render the output too.
 * @param {String} props.dateType Which date the object is dealing with. Can be "arrival", "departure" or "both". Default is "both".
 * @param {String} props.locale Language code. Default "en-US."
 * @param {String} props.UUID Unique Identifier. the default is randomly generated.
 * @param {Object} props.lexicon JSON object containing langauge strings.
 * @param {String} props.lexicon.arrivalString what is announced when the arrival date is updated. Default "the arrival date is [date]."
 * @param {String} props.lexicon.departureString what is announced when the departure date is updated. Default "the departure date is [date]."
 */
var NuCalAnnouncerView = /*#__PURE__*/function (_NuCalBaseView) {
  _inherits(NuCalAnnouncerView, _NuCalBaseView);

  var _super = _createSuper(NuCalAnnouncerView);

  function NuCalAnnouncerView(props) {
    _classCallCheck(this, NuCalAnnouncerView);

    props.view = props.view || document.getElementById("nuCalAnnouncer");

    if (props.view === null) {
      props.view = document.createElement("div");
      props.view.id = "nuCalAnnouncer";
      props.view.setAttribute("aria-live", "assertive");
      props.view.setAttribute("role", "alert");
      document.body.appendChild(props.view);
    }

    return _super.call(this, props);
  }

  _createClass(NuCalAnnouncerView, [{
    key: "subscribe",
    value: function subscribe() {
      this._subscriptions.push(_Events["default"].subscribe(this._events.datesUpdated, this.render.bind(this)));
    }
  }, {
    key: "render",
    value: function render(props) {
      this.view.innerHTML = "";
      var arrivalString = this.lexicon.NuCalAnnouncerView.arrivalText.replace("[date]", props.arrivalDate.toLocaleDateString({
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      }));
      var departureString = this.lexicon.NuCalAnnouncerView.departureText.replace("[date]", props.departureDate.toLocaleDateString({
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      }));
      this.view.innerHTML = "".concat(arrivalString, " ").concat(departureString);
    }
  }]);

  return NuCalAnnouncerView;
}(_NuCalBaseView2["default"]);

var _default = NuCalAnnouncerView;
exports["default"] = _default;

},{"../utils/Events.js":5,"./NuCalBaseView.js":10}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

var _lexicon = _interopRequireDefault(require("../utils/lexicon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* NuCalBaseView.
* @abstract 
* @param {Object} props properties.
* @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
* @param {HTMLElement} props.view The HTML Element in which this object should render the output too.
* @param {String} props.dateType Which date the object is dealing with. Can be "arrival", "departure" or "both". Default is "both".
* @param {String} props.locale Language code. Default "en-US."
* @param {String} props.UUID Unique Identifier. the default is randomly generated.
* @param {Object} props.lexicon The translation objects.
*/
var NuCalBaseView = /*#__PURE__*/function () {
  function NuCalBaseView(props) {
    _classCallCheck(this, NuCalBaseView);

    try {
      this.view = props.view || null;

      if (this.view === null) {
        throw new Error("view is not set");
      }

      this._subscriptions = [];
      this.dateType = props.dateType || "both";
      this.namespace = props.namespace || "";
      this.locale = props.locale || "en-US";
      this._lexicon = props.lexicon || _lexicon["default"].getLexicon(this.locale);
      this.UUID = (0, _v["default"])();
    } catch (e) {
      console.log(e);
      return e;
    }
  }
  /**
     * Where the output of the object is rendered too.
     * @type {HTMLElement}
     */


  _createClass(NuCalBaseView, [{
    key: "view",
    get: function get() {
      return this._view;
    },
    set: function set(v) {
      this._view = v;
    }
    /**
       * The locale which to use with `toLocaleDateString` and such.
       * @type {String}
       */

  }, {
    key: "locale",
    get: function get() {
      return this._locale;
    },
    set: function set(l) {
      this._locale = l;
    }
    /**
     * The translations in JSON
     */

  }, {
    key: "lexicon",
    get: function get() {
      return this._lexicon;
    },
    set: function set(l) {
      this._lexicon = l;
      this.render();
    }
    /**
       * The namespace in which this object should subscribe and publish events on.
       * @type {String}
       */

  }, {
    key: "namespace",
    get: function get() {
      return this._namespace;
    },
    set: function set(n) {
      this._namespace = n;

      this._subscriptions.forEach(function (sub) {
        sub.remove();
      });

      this._buildEvents();

      this.subscribe();
    }
  }, {
    key: "_buildEvents",
    value: function _buildEvents() {
      var n = this._namespace;

      if (typeof n == "string" && n !== "") {
        n = "/" + n;
      } else {
        n = "";
      }

      this._events = {};
      this._events.datesUpdated = "/nuCal".concat(n, "/datesUpdated");
      this._events.arrivalDateUpdated = "/nuCal".concat(n, "/arrivalDateUpdated");
      this._events.departureDateUpdated = "/nuCal".concat(n, "/departureDateUpdated");
      this._events.minDateUpdated = "/nuCal".concat(n, "/minDateUpdated");
      this._events.maxDateUpdated = "/nuCal".concat(n, "/maxDateUpdated");
      this._events.updateArrivalDate = "/nuCal".concat(n, "/updateArrivalDate");
      this._events.updateDepartureDate = "/nuCal".concat(n, "/updateDepartureDate");
      this._events.updateNumberOfNights = "/nuCal".concat(n, "/updateNumberOfNights");
      this._events.updateMinNumberOfNights = "/nuCal".concat(n, "/updateMinNumberOfNights");
      this._events.updateMaxNumberOfNights = "/nuCal".concat(n, "/updateMaxNumberOfNights");
    }
    /**
       * Which date the object is dealing with. Can be "arrival", "departure" or "both".
       * @type {String}
       * @default "both"
       */

  }, {
    key: "dateType",
    get: function get() {
      return this._dateType;
    },
    set: function set(type) {
      if (["departure", "arrival", "both"].indexOf(type) !== -1) {
        this._dateType = type;
      } else {
        console.log("not a valid dateType");
        this._dateType = "both";
      }
    }
    /**
       * The unique ID for the object.
       * @type {String}
       */

  }, {
    key: "UUID",
    get: function get() {
      return this._UUID;
    },
    set: function set(uuid) {
      this._UUID = uuid || (0, _v["default"])();
    }
    /**
       * overload this to add subscriptions in child classes. This will allow incoming messages from other
       * published of classes to be recieved and processed. Typically the callback for the subscription will
       * be `this.render()`.
       * @type {Undefined}
       */

  }, {
    key: "subscribe",
    value: function subscribe() {}
    /**
       * overload this to generate and render the output and update `this.view`. This method is typically the
       * callback from a subscription added in `this.subcribe`. The `props` recieved are
       * sent from what ever is publishing. 
       * @type {Undefined}
       */

  }, {
    key: "render",
    value: function render() {}
  }]);

  return NuCalBaseView;
}();

var _default = NuCalBaseView;
exports["default"] = _default;

},{"../utils/lexicon":7,"uuid/v4":17}],11:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Events = _interopRequireDefault(require("../utils/Events.js"));

var _NuCalBaseView2 = _interopRequireDefault(require("./NuCalBaseView.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @extends NuCalBaseView
 * @param {Object} props properties.
 * @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
 * @param {HTMLElement} props.view The HTML Element in which this object should render the output too.
 * @param {String} props.dateType Which date the object is dealing with. Can be "arrival", "departure" or "both". Default is "both".
 * @param {String} props.locale Language code. Default "en-US."
 * @param {String} props.UUID Unique Identifier. the default is randomly generated.
 * @param {Function(date)} props.renderTemplate A custom function that renders the template.
 */
var NuCalPrettyView = /*#__PURE__*/function (_NuCalBaseView) {
  _inherits(NuCalPrettyView, _NuCalBaseView);

  var _super = _createSuper(NuCalPrettyView);

  function NuCalPrettyView(props) {
    var _this;

    _classCallCheck(this, NuCalPrettyView);

    _this = _super.call(this, props);
    _this.classPrefix = props.classPrefix || "cp-nuCalPrettyView";
    _this.renderTemplate = props.renderTemplate instanceof Function ? props.renderTemplate : _this._defaultRenderTemplate;

    _this.view.classList.add("".concat(_this.classPrefix));

    return _this;
  }

  _createClass(NuCalPrettyView, [{
    key: "subscribe",
    value: function subscribe() {
      this._subscriptions.push(_Events["default"].subscribe(this._events.datesUpdated, this.render.bind(this)));
    }
  }, {
    key: "render",
    value: function render(props) {
      var date;

      if (this.dateType === "arrival") {
        date = props.arrivalDate;
      } else {
        date = props.departureDate;
      }

      this.renderTemplate(date);
    }
  }, {
    key: "_defaultRenderTemplate",
    value: function _defaultRenderTemplate(date) {
      this.view.innerHTML = "\n        <span class=\"".concat(this.classPrefix, "-date\">\n            ").concat(date.toLocaleDateString(this.locale, {
        "day": "2-digit"
      }), "\n        </span>\n        <span class=\"").concat(this.classPrefix, "-day after-arrow\">").concat(date.toLocaleDateString(this.locale, {
        "weekday": "short"
      }), "</span>\n        <span class=\"").concat(this.classPrefix, "-month\">").concat(date.toLocaleDateString(this.locale, {
        "month": "long"
      }), "</span>\n    ");
    }
  }]);

  return NuCalPrettyView;
}(_NuCalBaseView2["default"]);

var _default = NuCalPrettyView;
exports["default"] = _default;

},{"../utils/Events.js":5,"./NuCalBaseView.js":10}],12:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Events = _interopRequireDefault(require("../utils/Events.js"));

var _NuCalBaseView2 = _interopRequireDefault(require("./NuCalBaseView.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @extends NuCalBaseView
 * @param {Object} props properties.
 * @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
 * @param {HTMLElement} props.view The HTML Element in which this object should render the output too.
 * @param {String} props.dateType Which date the object is dealing with. Can be "arrival", "departure" or "both". Default is "both".
 * @param {String} props.locale Language code. Default "en-US."
 * @param {String} props.UUID Unique Identifier. the default is randomly generated.
 */
var NuCalSelectView = /*#__PURE__*/function (_NuCalBaseView) {
  _inherits(NuCalSelectView, _NuCalBaseView);

  var _super = _createSuper(NuCalSelectView);

  function NuCalSelectView(props) {
    var _this;

    _classCallCheck(this, NuCalSelectView);

    _this = _super.call(this, props);
    _this.classPrefix = props.classPrefix || "cp-nuCalSelectView";

    _this.view.classList.add("".concat(_this.classPrefix));

    var lexi = _this.dateType == 'arrival' ? _this.lexicon.NuCalSelectView.arrival : _this.lexicon.NuCalSelectView.departure;
    _this.view.innerHTML = "\n            <fieldset>\n                <label for=\"".concat(_this.classPrefix, "-").concat(_this.dateType, "-daySelect\">").concat(lexi.dayLabel, "</label>\n                <select id=\"").concat(_this.classPrefix, "-").concat(_this.dateType, "-daySelect\" aria-label=\"").concat(lexi.daySelectAria, "\" class=\"").concat(_this.classPrefix, "-daySelect\"></select>\n            </fieldset>\n            <fieldset>\n                <label for=\"").concat(_this.classPrefix, "-").concat(_this.dateType, "-monthSelect\">").concat(lexi.monthLabel, "</label>\n                <select id=\"").concat(_this.classPrefix, "-").concat(_this.dateType, "-monthSelect\" aria-label=\"").concat(lexi.monthSelectAria, "\" class=\"").concat(_this.classPrefix, "-monthSelect\"></select>\n            </fieldset>\n            <fieldset>\n                <label for=\"").concat(_this.classPrefix, "-").concat(_this.dateType, "-yearSelect\">").concat(lexi.yearLabel, "</label>\n                <select id=\"").concat(_this.classPrefix, "-").concat(_this.dateType, "-yearSelect\" aria-label=\"").concat(lexi.yearSelectAria, "\" class=\"").concat(_this.classPrefix, "-yearSelect\"></select>\n            </fieldset>\n        ");
    _this._yearSelect = _this.view.querySelector(".".concat(_this.classPrefix, "-yearSelect"));
    _this._monthSelect = _this.view.querySelector(".".concat(_this.classPrefix, "-monthSelect"));
    _this._daySelect = _this.view.querySelector(".".concat(_this.classPrefix, "-daySelect"));

    var selectDateChange = function selectDateChange(e) {
      e.preventDefault();
      var daysInMonth = new Date(_this._yearSelect.value, parseInt(_this._monthSelect.value) + 1, 0).getDate();
      _this.date = new Date(_this._yearSelect.value, _this._monthSelect.value, Math.min(_this._daySelect.value, daysInMonth));
      var dateChangeEvent = _this.dateType === "arrival" ? _this._events.updateArrivalDate : _this._events.updateDepartureDate;

      _Events["default"].publish(dateChangeEvent, {
        "date": _this.date
      });
    };

    _this._daySelect.addEventListener("change", selectDateChange);

    _this._monthSelect.addEventListener("change", selectDateChange);

    _this._yearSelect.addEventListener("change", selectDateChange);

    return _this;
  }

  _createClass(NuCalSelectView, [{
    key: "subscribe",
    value: function subscribe() {
      this._subscriptions.push(_Events["default"].subscribe(this._events.datesUpdated, this.render.bind(this)));
    }
  }, {
    key: "render",
    value: function render(props) {
      this.date;

      if (this.dateType === "arrival") {
        this.date = props.arrivalDate;
        this.minDate = props.minArrivalDate !== null ? new Date(props.minArrivalDate.valueOf()) : null;
        this.maxDate = props.maxArrivalDate !== null ? new Date(props.maxArrivalDate.valueOf()) : null;
      } else {
        this.date = props.departureDate;
        this.minDate = props.minDepartureDate !== null ? new Date(props.minDepartureDate.valueOf()) : null;
        this.maxDate = props.maxDepartureDate !== null ? new Date(props.maxDepartureDate.valueOf()) : null;
      }
      /*
                BUILD ACCESSIBLE SELECT BOXES
            */


      var playDate; //this is for playing with and getting formatting from.

      playDate = new Date(); //populate year select

      this._yearSelect.innerHTML = "";

      for (var i = this.minDate.getFullYear(); i <= this.maxDate.getFullYear(); i++) {
        playDate.setFullYear(i);
        var option = document.createElement("option");
        option.value = i;
        option.innerHTML = playDate.toLocaleDateString(this.locale, {
          year: "numeric"
        });

        this._yearSelect.add(option);

        if (this.date.getFullYear() === i) option.selected = true;
      } //populate month select


      this._monthSelect.innerHTML = "";
      var maxMonth = this.date.getFullYear() === this.maxDate.getFullYear() ? this.maxDate.getMonth() + 1 : 12;
      var minMonth = this.date.getFullYear() === this.minDate.getFullYear() ? this.minDate.getMonth() : 0;

      for (var x = minMonth; x < maxMonth; x++) {
        playDate.setDate(1);
        playDate.setMonth(x);

        var _option = document.createElement("option");

        _option.value = x;
        _option.innerHTML = playDate.toLocaleDateString(this.locale, {
          month: "long"
        });

        this._monthSelect.add(_option);

        if (this.date.getMonth() === x) _option.selected = true;
      } //populate date select


      playDate = new Date();
      playDate.setHours(0, 0, 0, 0);
      playDate.setMonth(this.date.getMonth());
      this._daySelect.innerHTML = "";
      var maxDay = this.date.getFullYear() === this.maxDate.getFullYear() && this.date.getMonth() === this.maxDate.getMonth() ? this.maxDate.getDate() : new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0).getDate();
      var minDay = this.date.getFullYear() === this.minDate.getFullYear() && this.date.getMonth() === this.minDate.getMonth() ? this.minDate.getDate() : 1;

      for (var _x = minDay; _x <= maxDay; _x++) {
        playDate.setDate(_x);

        var _option2 = document.createElement("option");

        _option2.value = _x;
        _option2.innerHTML = playDate.toLocaleDateString(this.locale, {
          "day": "2-digit"
        });

        this._daySelect.add(_option2);

        if (this.date.getDate() === _x) _option2.selected = true;
      }
    }
  }]);

  return NuCalSelectView;
}(_NuCalBaseView2["default"]);

exports["default"] = NuCalSelectView;

},{"../utils/Events.js":5,"./NuCalBaseView.js":10}],13:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Events = _interopRequireDefault(require("../utils/Events.js"));

var _NuCalBaseView2 = _interopRequireDefault(require("./NuCalBaseView.js"));

var _General = require("../utils/General.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @extends NuCalBaseView
 */
var NuCalSingleCalendarView = /*#__PURE__*/function (_NuCalBaseView) {
  _inherits(NuCalSingleCalendarView, _NuCalBaseView);

  var _super = _createSuper(NuCalSingleCalendarView);

  /**
     * @param {Object} props properties.
     * @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
     * @param {HTMLElement} props.view The HTML Element in which this object should render the output too.
     * @param {String} props.dateType Which date the object is dealing with. Can be "arrival", "departure" or "both". Default is "both".
     * @param {String} props.locale Language code. Default "en-US."
     * @param {String} props.UUID Unique Identifier. the default is randomly generated.
     * @param {Function} props.onDateSelect A callback for when a date is selected.
     * @param {String} props.classPrefix A custom class prefix.
     */
  function NuCalSingleCalendarView(props) {
    var _this;

    _classCallCheck(this, NuCalSingleCalendarView);

    _this = _super.call(this, props);
    _this.onDateSelect = props.onDateSelect;
    _this.classPrefix = props.classPrefix || "cp-nuCalSingleCalendar";

    _this.view.classList.add(_this.classPrefix);

    _this.view.innerHTML = "\n            <div class=\"".concat(_this.classPrefix, "-calendar\"></div>\n        ");
    _this.selectedDate = new Date();
    return _this;
  }
  /**
      * The selected Date depending on what `dateType` is set too.
      * @type {Date}.
     */


  _createClass(NuCalSingleCalendarView, [{
    key: "selectedDate",
    get: function get() {
      return this._selectedDate;
    },
    set: function set(d) {
      if (d instanceof Date) {
        this._selectedDate = d;

        this._selectedDate.setHours(0, 0, 0, 0);

        var dateChangeEvent = this.dateType === "arrival" ? this._events.updateArrivalDate : this._events.updateDepartureDate;

        _Events["default"].publish(dateChangeEvent, {
          "date": this._selectedDate
        });

        this.onDateSelect(d);
      }
    }
    /**
        * The focused Date, but not the actually selected one. This allows us to be looking
        * at another month or year without committing to it.
        * @type {Date}.
       */

  }, {
    key: "focusDate",
    get: function get() {
      return this._focusDate;
    },
    set: function set(d) {
      if (d instanceof Date) {
        var oldFocusDate = this._focusDate;
        this._focusDate = d;

        this._focusDate.setHours(0, 0, 0, 0);

        var focusClass = "".concat(this.classPrefix, "-cell--focused");

        if (this._focusDate.valueOf() < this.minDate.valueOf()) {
          this._focusDate = new Date(this.minDate.valueOf());
        }

        if (this._focusDate.valueOf() > this.maxDate.valueOf()) {
          this._focusDate = new Date(this.maxDate.valueOf());
        }

        if ( //Do we need to redraw calendar or just update the elements?
        this._focusDate.getMonth() === oldFocusDate.getMonth() && this._focusDate.getFullYear() === oldFocusDate.getFullYear()) {
          //Just update the elements
          this.view.querySelectorAll(".".concat(focusClass)).forEach(function (el) {
            el.classList.remove(focusClass);
            el.querySelector("button").tabIndex = -1;
          });
        } else {
          //redraw
          this.render();
          return; //render will recall this method to handle focus when we're done
        }

        var newFocus = this.getFocusDateElement();

        if (newFocus === null) {
          return;
        }

        newFocus.classList.add(focusClass);
        newFocus.querySelector("button").tabIndex = 0;
      }
    }
    /**
        *  returns the focused date cell.
        * @type {HTMLElement}
        */

  }, {
    key: "getFocusDateElement",
    value: function getFocusDateElement() {
      return this.view.querySelector(".".concat(this.classPrefix, "-cell[data-date=\"").concat(this._focusDate.getDate(), "\"]"));
    }
    /**
        * focuses the previous month.
        */

  }, {
    key: "focusPrevMonth",
    value: function focusPrevMonth() {
      this.focusDate = (0, _General.getPreviousMonth)(this.focusDate);
    }
    /**
        * focuses the next month.
        */

  }, {
    key: "focusNextMonth",
    value: function focusNextMonth() {
      this.focusDate = (0, _General.getNextMonth)(this.focusDate);
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      this._subscriptions.push(_Events["default"].subscribe(this._events.datesUpdated, this.update.bind(this)));
    }
    /**
        * A callback for when a date is selected.
        * @type {function}
        */

  }, {
    key: "onDateSelect",
    get: function get() {
      return this._onDateSelect;
    },
    set: function set(f) {
      this._onDateSelect = typeof f === "function" ? f : function () {};
    }
  }, {
    key: "_buildEvents",
    value: function _buildEvents() {
      _NuCalBaseView2["default"].prototype._buildEvents.call(this);

      var n = this._namespace;
      var id = this.UUID;

      if (typeof n == "string" && n !== "") {
        n = "/" + n;
      } else {
        n = "";
      }

      if (typeof id == "string" && id !== "") {
        id = "/" + id;
      } else {
        id = "";
      }

      this._events.calendarDayClicked = "/nuCal".concat(n).concat(id, "/calendarDayClicked");
    }
  }, {
    key: "update",
    value: function update(props) {
      if (this.dateType === "arrival") {
        this._selectedDate = props.arrivalDate;
        this._focusDate = props.arrivalDate;
        this.minDate = props.minArrivalDate !== null ? new Date(props.minArrivalDate.valueOf()) : null;
        this.maxDate = props.maxArrivalDate !== null ? new Date(props.maxArrivalDate.valueOf()) : null;
      } else {
        this._selectedDate = props.departureDate;
        this._focusDate = props.departureDate;
        this.minDate = props.minDepartureDate !== null ? new Date(props.minDepartureDate.valueOf()) : null;
        this.maxDate = props.maxDepartureDate !== null ? new Date(props.maxDepartureDate.valueOf()) : null;
      }

      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var prevMonth = (0, _General.getPreviousMonth)(this.focusDate);
      var nextMonth = (0, _General.getNextMonth)(this.focusDate);
      var lexi = this.lexicon.NuCalSingleCalendarView;
      console.log(lexi); //build visual calendar

      this.view.querySelector(".".concat(this.classPrefix, "-calendar")).innerHTML = "\n        <div class=\"".concat(this.classPrefix, "-header\">\n            <div class=\"").concat(this.classPrefix, "-monthArrowWrapper--prev\"><button type=\"button\" class=\"").concat(this.classPrefix, "-monthArrow ").concat(this.classPrefix, "-monthArrow--prev\"\n            aria-label=\"").concat(lexi.previousLabelAria, ". ").concat(prevMonth.toLocaleDateString(this.locale, {
        month: "long",
        year: "numeric"
      }), "\">").concat(lexi.previousLabel, "</button></div>\n            <div class=\"").concat(this.classPrefix, "-title\">").concat(this.focusDate.toLocaleDateString(this.locale, {
        month: "short",
        year: "numeric"
      }), "</div>\n            <div class=\"").concat(this.classPrefix, "-monthArrowWrapper--next\"><button type=\"button\" class=\"").concat(this.classPrefix, "-monthArrow ").concat(this.classPrefix, "-monthArrow--next\"\n            aria-label=\"").concat(lexi.nextLabelAria, " ").concat(nextMonth.toLocaleDateString(this.locale, {
        month: "long",
        year: "numeric"
      }), "\">").concat(lexi.nextLabel, "</button></div>\n        </div>");
      this.view.querySelector(".".concat(this.classPrefix, "-calendar")).appendChild(this._buildTable());
      this._prevMonthButton = this.view.querySelector(".".concat(this.classPrefix, "-monthArrow--prev"));
      this._nextMonthButton = this.view.querySelector(".".concat(this.classPrefix, "-monthArrow--next"));

      if (this.minDate.getFullYear() === this.focusDate.getFullYear() && this.minDate.getMonth() === this.focusDate.getMonth()) {
        this._prevMonthButton.disabled = true;
      }

      if (this.maxDate.getFullYear() === this.focusDate.getFullYear() && this.maxDate.getMonth() === this.focusDate.getMonth()) {
        this._nextMonthButton.disabled = true;
      }

      this._prevMonthButton.addEventListener("click", function (e) {
        e.preventDefault();

        _this2.focusPrevMonth();

        _this2._prevMonthButton.focus();
      });

      this._nextMonthButton.addEventListener("click", function (e) {
        e.preventDefault();

        _this2.focusNextMonth();

        _this2._nextMonthButton.focus();
      });

      this.focusDate = this.focusDate; //refocus
    }
  }, {
    key: "_buildTable",
    value: function _buildTable() {
      var _this3 = this;

      var daysInMonth = new Date(this.focusDate.getFullYear(), this.focusDate.getMonth() + 1, 0).getDate();
      var dayOffset = (0, _General.getMonthPadding)(this.focusDate);
      var firstDayOfMonth = new Date(this.focusDate.getFullYear(), this.focusDate.getMonth(), 1);
      var playDate; //this is for playing with and getting formatting from.

      playDate = new Date(this.focusDate.getFullYear(), this.focusDate.getMonth(), 1 - dayOffset);
      var calRow = null;
      var calTable = document.createElement("table");
      calTable.classList.add(".".concat(this.classPrefix, "-dates"));
      calTable.setAttribute("role", "presentation"); //TABLE HEADER

      var calHeader = document.createElement("tr"); //Set to Sunday

      playDate = new Date();
      playDate.setDate(playDate.getDate() - playDate.getDay()); //set to a sunday

      for (var i = 0; i < 7; i++) {
        var thCell = document.createElement("th");
        thCell.innerHTML = playDate.toLocaleDateString(this.locale, {
          weekday: "short"
        });
        calHeader.appendChild(thCell);
        playDate.setDate(playDate.getDate() + 1);
      }

      calTable.appendChild(calHeader); //table Cells

      for (var _i = 1; _i <= dayOffset + daysInMonth; _i++) {
        //create a row when needed
        if ((_i - 1) % 7 === 0) {
          if (calRow !== null) {
            calTable.appendChild(calRow);
          }

          calRow = document.createElement("tr");
        }

        playDate = new Date(this.focusDate.getFullYear(), this.focusDate.getMonth(), _i - dayOffset);
        var cellContent = playDate.toLocaleDateString(this.locale, {
          "day": "2-digit"
        });
        var cell = document.createElement("td");
        cell.classList.add("".concat(this.classPrefix, "-cell"));

        if (playDate.valueOf() < firstDayOfMonth.valueOf()) {
          //padding
          cell.classList.add("".concat(this.classPrefix, "-cell--disabled"));
          cell.classList.add("".concat(this.classPrefix, "-cell--padding"));
          calRow.appendChild(cell);
          continue;
        } else {
          //date days
          if (playDate.valueOf() < this.minDate.valueOf() || playDate.valueOf() > this.maxDate.valueOf()) {
            //disabled date days
            cell.classList.add("".concat(this.classPrefix, "-cell--disabled"));
            var button = document.createElement("button");
            button.disabled = true;
            button.innerHTML = cellContent;
            cell.appendChild(button);
            calRow.appendChild(cell);
            continue;
          } else {
            (function () {
              //active days
              cell.dataset.date = playDate.getDate();
              cell.dataset.month = playDate.getMonth() + 1;
              cell.dataset.year = playDate.getFullYear();

              if (playDate.valueOf() === _this3.selectedDate.valueOf()) {
                cell.classList.add("".concat(_this3.classPrefix, "-cell--selected"));
              }

              var button = document.createElement("button");
              button.innerHTML = cellContent;
              button.setAttribute("aria-label", playDate.toLocaleDateString(_this3.locale, {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric"
              }));
              button.tabIndex = -1;
              var d = new Date(playDate.getFullYear(), playDate.getMonth(), playDate.getDate());
              var columnNo = d.getDay();
              var rowNo = calTable.childElementCount;
              button.addEventListener("click", function (e) {
                e.preventDefault();

                _Events["default"].publish(_this3._events.calendarDayClicked, {
                  "date": d
                });

                _this3.selectedDate = d;

                _this3.setFocusDateAndFocus(d);
              });
              var prevMonthPadding = (0, _General.getMonthPadding)(new Date(d.getFullYear(), d.getMonth() - 1, 1));
              var daysInNextMonth = (0, _General.getDaysInNextMonth)(d);
              button.addEventListener("keydown", function (e) {
                var newDate;

                switch (e.key) {
                  case "Home":
                    newDate = new Date(d.getFullYear(), d.getMonth(), 1);
                    break;

                  case "End":
                    newDate = new Date(d.getFullYear(), d.getMonth() + 1, 0);
                    break;

                  case "ArrowUp":
                    newDate = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 7);

                    _this3.setFocusDateAndFocus(newDate);

                    e.preventDefault();
                    break;

                  case "ArrowDown":
                    newDate = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 7);

                    _this3.setFocusDateAndFocus(newDate);

                    e.preventDefault();
                    break;

                  case "ArrowLeft":
                    if (d.getDate() === 1) {
                      newDate = new Date(d.getFullYear(), d.getMonth() - 1, 7 - prevMonthPadding);
                    } else if (columnNo === 0) {
                      var shiftDate = rowNo * 7 + columnNo - prevMonthPadding;
                      newDate = new Date(d.getFullYear(), d.getMonth() - 1, shiftDate);

                      if (newDate.getMonth() === d.getMonth()) {
                        //padding might throw this off
                        newDate = new Date(d.getFullYear(), d.getMonth(), 0);
                      }
                    } else {
                      newDate = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1);
                    }

                    _this3.setFocusDateAndFocus(newDate);

                    e.preventDefault();
                    break;

                  case "ArrowRight":
                    if (columnNo === 6) {
                      if (rowNo === 1) {
                        newDate = new Date(d.getFullYear(), d.getMonth() + 1, 1);
                      } else {
                        var _shiftDate = rowNo * 7 - (0, _General.getMonthPadding)(new Date(d.getFullYear(), d.getMonth() + 1, 1)) - columnNo;

                        newDate = new Date(d.getFullYear(), d.getMonth() + 1, _shiftDate);
                      }
                    } else if (d.getDate() === (0, _General.getDaysInMonth)(d)) {
                      var tempDate = new Date(d.getFullYear(), d.getMonth() + 1, daysInNextMonth);
                      newDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), daysInNextMonth - tempDate.getDay());
                    } else {
                      newDate = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
                    }

                    _this3.setFocusDateAndFocus(newDate);

                    e.preventDefault();
                    break;
                }
              });
              cell.appendChild(button);
              calRow.appendChild(cell);
            })();
          }
        }
      }

      if (calRow !== null) {
        if (calRow.childNodes.length !== 0) calTable.appendChild(calRow);
      }

      return calTable;
    }
    /**
        * set the focus date and focus it
        * @param {Date} d 
        */

  }, {
    key: "setFocusDateAndFocus",
    value: function setFocusDateAndFocus(d) {
      this.focusDate = d;
      var focusCell = this.getFocusDateElement();
      if (focusCell) focusCell.querySelector("button").focus();
    }
  }]);

  return NuCalSingleCalendarView;
}(_NuCalBaseView2["default"]);

var _default = NuCalSingleCalendarView;
exports["default"] = _default;

},{"../utils/Events.js":5,"../utils/General.js":6,"./NuCalBaseView.js":10}],14:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _NuCalBaseView2 = _interopRequireDefault(require("../NuCalBaseView.js"));

var _NuCalSingleCalendarView = _interopRequireDefault(require("../NuCalSingleCalendarView.js"));

var _NuCalSelectView = _interopRequireDefault(require("../NuCalSelectView.js"));

var _NuCalPrettyView = _interopRequireDefault(require("../NuCalPrettyView.js"));

var _General = require("../../utils/General.js");

var _Events = _interopRequireDefault(require("../../utils/Events.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @extends NuCalBaseView
 * @param {Object} props properties.
 * @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
 * @param {HTMLElement} props.view The HTML Element in which this object should render the output too.
 * @param {String} props.dateType Which date the object is dealing with. Can be "arrival", "departure" or "both". Default is "both".
 * @param {String} props.locale Language code. Default "en-US."
 * @param {String} props.UUID Unique Identifier. the default is randomly generated.
 * @param {Function(date)} props.toggleRenderTemplate A custom function that renders the button template.
 * @param {String} props.classPrefix A custom class prefix.
 * @param {String} props.inputId value for the id attribute for the hidden input value.
 * @param {String} props.inputName value for the name attribute for the hidden input value.
 * @param {Object} props.lexicon The translation objects.
 */
var NuCalSingleCalendarWidget = /*#__PURE__*/function (_NuCalBaseView) {
  _inherits(NuCalSingleCalendarWidget, _NuCalBaseView);

  var _super = _createSuper(NuCalSingleCalendarWidget);

  function NuCalSingleCalendarWidget(props) {
    var _this;

    _classCallCheck(this, NuCalSingleCalendarWidget);

    var superResult = _this = _super.call(this, props);

    if (superResult instanceof Error) {
      return _possibleConstructorReturn(_this, superResult);
    }

    _this.inputId = props.inputId || _this.UUID;
    _this.inputName = props.inputName || _this.UUID;
    _this.classPrefix = props.classPrefix || "cp-nuCalSingleCalendarWidget";
    _this.view.innerHTML = "\n                <div class=\"".concat(_this.classPrefix, "\">\n                    <input type=\"hidden\" name=\"").concat(props.inputName, "\" id=\"").concat(props.inputId, "\">\n                    <button type=\"button\" tabindex=\"0\" class=\"").concat(_this.classPrefix, "-toggle\"></button>\n                    <div class=\"").concat(_this.classPrefix, "-mask\"></div>\n                    <div class=\"").concat(_this.classPrefix, "-calContainer\">\n                        <div class=\"").concat(_this.classPrefix, "-select\"></div>\n                        <div class=\"").concat(_this.classPrefix, "-calendar\"></div>\n                        <button type=\"button\" aria-label=\"close-calendar\" class=\"").concat(_this.classPrefix, "-close\"></button>\n                    </div>\n                </div>\n        ");

    var closeEventCallback = function closeEventCallback(e) {
      e.preventDefault();
      _this.isOpen = false;
    };

    _this.view.addEventListener("keydown", function (e) {
      if (e.key == "Escape") {
        closeEventCallback(e);
      }
    });

    _this.input = _this.view.querySelector("#".concat(_this.inputId));
    _this.toggleButton = new _NuCalPrettyView["default"]({
      "view": _this.view.querySelector(".".concat(_this.classPrefix, "-toggle")),
      "namespace": _this.namespace,
      "dateType": _this.dateType,
      "locale": _this.locale,
      "lexicon": _this.lexicon,
      "renderTemplate": props.toggleRenderTemplate
    });

    _this.toggleButton.view.addEventListener("click", function (e) {
      e.preventDefault();

      _this.toggleOpen();
    });

    if (!(_this.toggleButton.view instanceof HTMLButtonElement)) {
      _this.toggleButton.view.addEventListener("keydown", function (e) {
        switch (e.key) {
          case "Enter":
          case "Space":
          case " ":
            _this.isOpen = true;
            break;
        }
      });
    }

    _this.mask = _this.view.querySelector(".".concat(_this.classPrefix, "-mask"));

    _this.mask.addEventListener("click", closeEventCallback);

    _this.closeButton = _this.view.querySelector(".".concat(_this.classPrefix, "-close"));

    _this.closeButton.addEventListener("click", closeEventCallback);

    _this.selects = new _NuCalSelectView["default"]({
      "view": _this.view.querySelector(".".concat(_this.classPrefix, "-select")),
      "namespace": _this.namespace,
      "dateType": _this.dateType,
      "locale": _this.locale,
      "lexicon": _this.lexicon
    });
    _this.calendar = new _NuCalSingleCalendarView["default"]({
      "view": _this.view.querySelector(".".concat(_this.classPrefix, "-calendar")),
      "namespace": _this.namespace,
      "dateType": _this.dateType,
      "locale": _this.locale,
      "lexicon": _this.lexicon
    });
    _this.calContainer = _this.view.querySelector(".".concat(_this.classPrefix, "-calContainer"));
    _this._focusableElements = (0, _General.getFocusableElements)(_this.calContainer);

    _this._focusableElements.forEach(function (el) {
      el.addEventListener("blur", function (event) {
        if (_this.isOpen) (0, _General.focusLock)(event, _this.calContainer);
      });
    });

    _this.isOpen = props.isOpen;
    _this.closeOnCalendarSelect = props.closeOnCalendarSelect;
    return _this;
  }
  /**
      * Toggles whether the widget it open or closed.
      */


  _createClass(NuCalSingleCalendarWidget, [{
    key: "toggleOpen",
    value: function toggleOpen() {
      this.isOpen = !this.isOpen;
    }
    /**
        * Set whether the widget is open or closed.
        * @type {Boolean}.
       */

  }, {
    key: "isOpen",
    get: function get() {
      return this._isOpen;
    },
    set: function set(b) {
      var _this2 = this;

      var wasOpen = this.isOpen;
      this._isOpen = typeof b === "boolean" ? b : false;

      if (this.isOpen) {
        this.calContainer.classList.add("".concat(this.classPrefix, "-calContainer--open"));
        this.calContainer.classList.remove("".concat(this.classPrefix, "-calContainer--closed"));
        this.mask.classList.add("".concat(this.classPrefix, "-mask--on"));
        this.mask.classList.remove("".concat(this.classPrefix, "-mask--off"));
        this.toggleButton.view.classList.add("".concat(this.classPrefix, "-toggle--on"));
        this.toggleButton.view.classList.remove("".concat(this.classPrefix, "-toggle--off"));

        this._focusableElements[0].focus();
      } else {
        this.calContainer.classList.remove("".concat(this.classPrefix, "-calContainer--open"));
        this.calContainer.classList.add("".concat(this.classPrefix, "-calContainer--closed"));
        this.mask.classList.remove("".concat(this.classPrefix, "-mask--on"));
        this.mask.classList.add("".concat(this.classPrefix, "-mask--off"));
        this.toggleButton.view.classList.remove("".concat(this.classPrefix, "-toggle--on"));
        this.toggleButton.view.classList.add("".concat(this.classPrefix, "-toggle--off"));
        if (wasOpen) setTimeout(function () {
          _this2.toggleButton.view.focus();
        }, 50);
      }
    }
    /**
        * Set whether to close the calendar to close when a date is selected.
        * @type {Boolean}.
       */

  }, {
    key: "closeOnCalendarSelect",
    get: function get() {
      return this._closeOnCalendarSelect;
    },
    set: function set(b) {
      var _this3 = this;

      this._closeOnCalendarSelect = typeof b === "boolean" ? b : false;
      this.calendar.onDateSelect = this._closeOnCalendarSelect ? function () {
        _this3.isOpen = false;
      } : function () {};
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      this._subscriptions.push(_Events["default"].subscribe(this._events.datesUpdated, this.update.bind(this)));
    }
  }, {
    key: "update",
    value: function update(props) {
      var date;

      if (this.dateType === "arrival") {
        date = props.arrivalDate;
      } else {
        date = props.departureDate;
      }

      this.input.value = "".concat(date.getFullYear(), "-").concat((0, _General.zeroPadNumber)(date.getMonth() + 1, 2), "-").concat((0, _General.zeroPadNumber)(date.getDate(), 2));
    }
  }]);

  return NuCalSingleCalendarWidget;
}(_NuCalBaseView2["default"]);

exports["default"] = NuCalSingleCalendarWidget;

},{"../../utils/Events.js":5,"../../utils/General.js":6,"../NuCalBaseView.js":10,"../NuCalPrettyView.js":11,"../NuCalSelectView.js":12,"../NuCalSingleCalendarView.js":13}],15:[function(require,module,exports){
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;

},{}],16:[function(require,module,exports){
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

},{}],17:[function(require,module,exports){
var rng = require('./lib/rng');
var bytesToUuid = require('./lib/bytesToUuid');

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;

},{"./lib/bytesToUuid":15,"./lib/rng":16}]},{},[1])

